import { INCORPORATION_FORM_SOURCE } from "constants/incorporation";
import {
  FormTree,
  useGetFormInstanceTreeQuery,
  useGetFormTemplateTreeQuery,
} from "store/apis/incorporationFormBuilder";
import { skipToken } from "@reduxjs/toolkit/query";

export type { FormTree };

type UseIncorporationFormTreeArgs = {
  source: "instance" | "template";
  contentId: string;
};

export const useIncorporationFormTree = ({
  source,
  contentId,
}: UseIncorporationFormTreeArgs) => {
  const instanceResult = useGetFormInstanceTreeQuery(
    source === INCORPORATION_FORM_SOURCE.INSTANCE
      ? { formInstanceId: contentId }
      : skipToken
  );

  const templateResult = useGetFormTemplateTreeQuery(
    source === INCORPORATION_FORM_SOURCE.TEMPLATE
      ? { templateId: contentId }
      : skipToken
  );

  return source === INCORPORATION_FORM_SOURCE.TEMPLATE
    ? templateResult
    : instanceResult;
};
